<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          'A shared ID happens when two different people are assigned the same identifier.'
          + 'If an identifier is shared, one of the records should be split to a new master record and identifier.'
          + 'History records will need to be assigned to the corresponding master record.',
        ],
      },
      {
        header: 'Reason for Split:',
        body: ['A Reason must be entered for the split. This information is stored with the record for future reference.'],
      },
      {
        body: ['A identifier split process cannot be reverted. Do not click Split ID unless the information has been verified.'],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
